<template>

  <div class="login-all-box">
<!--    <a-modal-->
<!--      title="提示"-->
<!--      :visible="loading"-->

<!--    >-->
<!--      <p> 登陆中,请稍后... </p>-->
<!--    </a-modal>-->

    <div class="login-box">

      <div class="login-title">设施园艺管理项目</div>
      <a-form-model
        :model="loginForm"
        ref="loginForm"
        name="basic"
        :rules="loginFormRules"
        @onFinish="onFinish"
        @onFinishFailed="onFinishFailed"
        :label-col="{ span: 4 }" :wrapper-col="{ span: 17}"
        style="width:100%;color: #ffffff"
        class="login-form"
      >
        <a-form-model-item
          label="账号"
          name="username"
          prop="loginID"
        >
          <a-input type="text" class="login-input" autocomplete="off"

                   v-model="loginForm.loginID"
                   placeholder="登录账号"/>
          <!-- <Input /> -->
        </a-form-model-item>

        <a-form-model-item
          label="密码"
          name="password"
          prop="loginPwd"
        >
          <a-input-password type="text"
                   v-model="loginForm.loginPwd"
                   placeholder="登录密码"
                   class="login-input1"
          />
          <!-- <Input.Password /> -->
        </a-form-model-item>

        <a-form-model-item label="." class="submit-button-form-box" name="remember" valuePropName="checked">
<!--          <a-row>-->
<!--            <a-col :span="18" :offset="6" style="color: white">-->
              <a-checkbox v-model="loginForm.check" style="color: white">记住密码</a-checkbox>
<!--            </a-col>-->
<!--          </a-row>-->
        </a-form-model-item>

        <a-form-model-item label="." class="submit-button-form-box">
<!--          <a-row>-->
<!--            <a-col :span="24" :offset="6">-->
<!--              <a-button type="primary" class="login-button" @click="login" block>登录</a-button>-->
<!--            </a-col>-->
<!--          </a-row>-->
<!--          <div class="login-button-box">-->
            <a-button type="primary" class="login-button" @click="bylogin"  block>登录</a-button>

<!--          </div>-->

          <!-- <Button type="primary" htmlType="submit">
            Submit
          </Button> -->
        </a-form-model-item>
      </a-form-model>
      <!-- <input type="text" class="login-input" v-model="login.A001001" placeholder="登录账号">
      <input type="text" class="login-input" v-model="login.loginPwd" placeholder="登录密码">
      <a-button type="primary" class="login-button" @click="login">登录</a-button> -->
    </div>
    <loading v-show="loading"> </loading>
  </div>
</template>

<script>
  import { _getProductData, _getThingModels } from '@/common/request'
  import Loading from '@/components/Loading'

  const Base64 = require('js-base64').Base64
  export default {
    name: 'loginPage',
    components: {
      Loading
    },
    data() {
      return {
        time:null,
        queryInfo:{
          productkey:"",
          devicename:"",
          keyword:"",
          cEntID:""
        },
        loginForm:{
          loginID:"",
          loginPwd:"",
          cSystem:"设施园艺",
          check:false
        },
        // 校验规则//
        loginFormRules: {
          // 登录名校验//
          loginID: [
            { required: true, message: '请输入登录名称', trigger: 'blur' },
            { min: 3, max: 10, message: '长度在 3 到 10 个字符', trigger: 'blur' }
          ],
          // 密码校验//
          loginPwd: [
            { required: true, message: '请输入登录密码', trigger: 'blur' },
            { min: 0, max: 20, message: '长度在 0 到 20 个字符', trigger: 'blur' }]
        },
        user:{},
        check:false,
        dataloading:false,
        res:null,
        lock:false,
        loading: false

      }
    },
    created(){

    },
    mounted(){
      let account = this.getCookie("account")
      let password = Base64.decode(this.getCookie("password"))
      let check=this.getCookie("check");

      if(account){
       this.loginForm.loginID=account;
       this.loginForm.loginPwd=password;
       this.loginForm.check=check;
      }
      this.getProductData()

      this.$cookies.set("this_defaultSelectedKeys", '',0)
      this.$cookies.set("____defaultSelectedKeys0",'',0)
      this.$cookies.set("___siderSubData",'',0)
    },
    methods:{
      async getProductData(){
        await _getProductData(this,JSON.stringify(this.queryInfo))

        this.getThingModels();

      },
      async getThingModels(){

        var ProductKeys = this.$store.getters.Products.map(item => item.ProductKey).join(",")

          this.res=await _getThingModels(this,{productKey:ProductKeys})
      },
    async  bylogin(){
        let that=this;
        that.lock=false;
      that.loading= true;
        while (true) {
          if(that.lock) break;
          await new Promise(res => setTimeout(res, 1000));
          that.login()
        }
      },
      login () {
        var _this = this
          //if (_this.res && _this.res.code == "200") {
            _this.lock=true;

            _this.$refs.loginForm.validate(async valid => {

              if (!valid) {
                _this.$message.success("验证失败!")
                _this.loading=false;
                return
              } else {
                try {
                  const { data: res } = await _this.$http.post('Login', _this.loginForm)

                  _this.setUserInfo();
                  _this.loading=false;
                  if (res.code == "200") {

                    _this.$message.success('登录成功！')
                    _this.$store.commit('setUser', res.obj.loginUser);
                    _this.$store.commit('setToken', res.obj.token);
                    // window.sessionStorage.setItem('user', res.obj.loginUser)
                    // window.sessionStorage.setItem('token', res.obj.token)
                    _this.toLayoutPage();
                  } else {
                    _this.$message.error('登录失败:' + res.message)

                  }

                } catch (error) {
                  _this.loading=false;
                  _this.$message.error('登录失败:接口无法请求')

                }
              }

            })

          //}

      },
      toLayoutPage:function () {
        this.$router.push('/largerScreen/largerSiderPage')
      },
      onFinish: function(values){
        console.log('Success:', values);
      },
      onFinishFailed: function(errorInfo) {
        console.log('Failed:', errorInfo);
      },
      //储存表单信息
      setUserInfo() {
        // 判断用户是否勾选记住密码，如果勾选，向cookie中储存登录信息，
        // 如果没有勾选，储存的信息为空
        if(this.check){
          this.setCookie("account",this.loginForm.loginID)
          // base64加密密码

          let passWord = Base64.encode(this.loginForm.loginPwd)
          this.setCookie("password",passWord)
          this.setCookie("check",true)
        }else{
          this.setCookie("account","")
          this.setCookie("password","")
          this.setCookie("check","")
        }
      },
      // 获取cookie
      getCookie: function (key) {
        if (document.cookie.length > 0) {
          var start = document.cookie.indexOf(key + '=')
          if (start !== -1) {
            start = start + key.length + 1
            var end = document.cookie.indexOf(';', start)
            if (end === -1) end = document.cookie.length
            return unescape(document.cookie.substring(start, end))
          }
        }
        return ''
      },
      // 保存cookie
      setCookie: function (cName, value, expiredays) {
        var exdate = new Date()
        exdate.setDate(exdate.getDate() + expiredays)
        document.cookie = cName + '=' + decodeURIComponent(value) +
          ((expiredays == null) ? '' : ';expires=' + exdate.toGMTString())
      }
    },
    beforeDestroy() {

      clearInterval(this.time);
    }
  }
</script>

<style scoped>
  .login-all-box{
    background: url("../../img/loginBg.png") no-repeat center center;
    background-size: cover;
    width: 100%;
    height: 100%;
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .login-box{
    background: rgba(0, 0, 0, 0.5);
    width: 31.5%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: white !important;
  }

  .login-title{
    font-size: 250%;
    margin-top: 7% ;
    margin-bottom: 5%;
    font-weight: bold;
    color: white;
    width: 100%;
    text-align: center;
  }

  /deep/.login-input{
    border: 1px solid rgba(255, 255, 255, 0.5);
    background-color: rgba(255, 255, 255, 0.1);
    padding: 0px 16px;
    width: 100%;
    margin-top: 1%;
    margin-bottom: 1%;
    color: white;
    border-radius: 3px;
  }

  /deep/.login-input:hover{
    border: 1px solid rgba(255, 255, 255, 0.5);
    background-color: rgba(255, 255, 255, 0.1);
    padding: 0px 16px;
    width: 100%;
    margin-top: 1%;
    margin-bottom: 1%;
    color: white;
    border-radius: 3px;
  }

  /deep/.login-input1 input{
    border: 1px solid rgba(255, 255, 255, 0.5);
    background-color: rgba(255, 255, 255, 0.1) !important;
    padding: 0px 16px;
    width: 100%;
    margin-top: 1%;
    margin-bottom: 1%;
    color: white;
    border-radius: 3px;
  }

  /deep/.login-input1 input:hover{
    border: 1px solid rgba(255, 255, 255, 0.5);
    background-color: rgba(255, 255, 255, 0.1);
    padding: 0px 16px;
    width: 100%;
    margin-top: 1%;
    margin-bottom: 1%;
    color: white;
    border-radius: 3px;
  }

  input::-webkit-input-placeholder,textarea::-webkit-input-placeholder{
    color: rgba(255, 255, 255, 0.7);
  }

  .login-button-box{
    width: 100%;
    text-align: center;
  }

  .login-button{
    /*width: 80%;*/
    margin-bottom: 15%;
    /*margin-top: 5%;*/
  }

  /deep/.login-form label{
    color: #ffffff;
    font-size: 110%;
  }

  /deep/.submit-button-form-box label{
    color: rgba(0,0,0,0);
  }

</style>


